import _classCallCheck from '../../../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../../../@babel/runtime/helpers/esm/createClass.js';
import _defineProperty from '../../../../@babel/runtime/helpers/esm/defineProperty.js';
import { ValueSetter } from './Setter.js';

var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();

export { Parser };
